// extracted by mini-css-extract-plugin
export default {"customCheckbox":"styles_customCheckbox__KG1B7"};